import { ApolloError, DocumentNode, gql } from '@apollo/client';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { useGraphql } from 'utils/hooks/useGraphql';
import { isDefined } from 'utils/tsHelpers';
import noOp from 'utils/noop';
import { GraphQLSnippet } from '../types';

export type UseSnippetByIdResponse = {
  errorMessage?: ApolloError;
  hasError?: boolean;
  isLoading: boolean;
  results: GraphQLSnippet;
  refetch: () => void;
};

type Variables = {
  id: number;
};

/**
 * Raw respone from GQL.
 */
type FetchSnippetByIdQueryResponse = {
  fetchSnippetById: GraphQLSnippet;
};

const dateTime = new Date().toISOString();
export const defaultSnippet = {
  content: '',
  createdAt: dateTime,
  creatorUserId: '',
  description: '',
  id: 0,
  name: '',
  positionalParameters: [],
  projectId: 0,
  updatedAt: dateTime,
  updatedBy: '',
  creatorUser: {
    id: '',
    fullName: '',
    avatarUrl: '',
  },
  updatedByUser: {
    id: '',
    fullName: '',
    avatarUrl: '',
  },
  __typename: GRAPHQL_TYPENAMES.SNIPPET,
};

export const fetchSnippetByIdQuery = gql`
  query FetchSnippetById($id: Long!) {
    fetchSnippetById(id: $id) {
      content
      description
      id
      name
      positionalParameters
      __typename
    }
  }
`;

/**
 * A fn to
 * @param getVariables - a fn that returns something serializable to send to the API
 */
export function useSnippetById(
  variables: Variables,
  query: DocumentNode = fetchSnippetByIdQuery,
): UseSnippetByIdResponse {
  const {
    data: snippetQueryData,
    error: hasError,
    errorMessage,
    isLoading,
    // previousData,
    refetch,
  } = useGraphql(query, {
    notifyOnNetworkStatusChange: true,
    variables,
  });

  // protect against the undefined response while the query is running
  if (isDefined<FetchSnippetByIdQueryResponse>(snippetQueryData)) {
    return {
      errorMessage,
      hasError,
      isLoading,
      refetch,
      results: snippetQueryData.fetchSnippetById || defaultSnippet,
    };
  }

  return {
    errorMessage,
    hasError: false,
    isLoading,
    refetch: noOp,
    results: defaultSnippet,
  };
}
